// -----------------------------------------------------------------------------
// Libraries
// -----------------------------------------------------------------------------
import React, { useCallback } from "react";
import { Modal, notification } from "antd";
import { loadStripe } from "@stripe/stripe-js/pure";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import cx from "classnames";

// -----------------------------------------------------------------------------
// Components and Helpers
// -----------------------------------------------------------------------------
import { Heading2 } from "themes/default/_typography";
import { useStripeCreateGymCheckoutSessionMutation } from "store/api/api";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

// -----------------------------------------------------------------------------
// Modal Component
// -----------------------------------------------------------------------------
const GymSubscriptionModal = ({ open, onClose, gymId, productName, onComplete }) => {
	const [createSession] = useStripeCreateGymCheckoutSessionMutation();

	const fetchClientSecret = useCallback(async () => {
		try {
			const { data } = await createSession({
				gym_id: gymId,
				product_name: productName,
			});
			return data.client_secret;
		} catch (err) {
			notification.error({ message: "Failed to create gym checkout session." });
		}
	}, [createSession, gymId, productName]);

	return (
		<Modal
			className={cx("sb-gym-subscription-modal")}
			title={<Heading2>Subscribe to {productName}</Heading2>}
			centered
			open={open}
			onCancel={onClose}
			width={656}
			footer={null}
			maskClosable={false}
			closable
			destroyOnClose
		>
			<div id="checkout">
				<EmbeddedCheckoutProvider stripe={stripePromise} options={{ fetchClientSecret, onComplete }}>
					<EmbeddedCheckout />
				</EmbeddedCheckoutProvider>
			</div>
		</Modal>
	);
};

export default GymSubscriptionModal;

